module.exports = __webpack_public_path__ + "static/media/parallax-bg.26dee855.svg";